import { useParams } from "react-router-dom";
import { Eye } from "lucide-react";
import BlockRendererPage from "@/components/blocks/BlockRenderer";

// Unlisted admin-only route that renders a `<slug>__draft` version of a page.
// Rendered inside the normal PublicShell (header + footer) so admins can preview
// the exact look of the draft before promoting.
//
// The BlockRendererPage internally hits GET /api/site-pages/<slug>__draft which
// returns the draft doc if it exists, or 404s. Preview slugs are not exposed
// on the site anywhere — the URL only works when an admin knows the path.
export default function DraftPreviewPage() {
  const { slug } = useParams();
  return (
    <>
      <div
        className="fixed top-20 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 rounded-full bg-amber-500 text-white text-xs font-bold px-4 py-2 shadow-lg"
        data-testid="draft-preview-banner"
      >
        <Eye className="h-3.5 w-3.5" />
        Draft preview · {slug}
      </div>
      <BlockRendererPage slug={`${slug}__draft`} testId={`preview-${slug}-page`} />
    </>
  );
}
